<app-dropdown-menu
  [icon]="'settings'"
  [stylingClass]="'simple-setting-button'"
>
  @for (operation of operations; track $index) {
    <app-dropdown-menu-item
      class="operation-dropdown-menu__menu"
      [icon]="operation.menu_icon"
      (click)="openOperation(operation)"
      (keydown)="null"
      [text]="operation.menu_title"
      [disabled]="operation.$$disabled"
      [matTooltip]="operation.$$disabled && operation.$$toolTip"
    ></app-dropdown-menu-item>
  }

  <app-dropdown-menu-item
    class="operation-dropdown-menu__menu"
    [icon]="nameColumnHidden ? 'visibility' : 'visibility_off'"
    (click)="toggleNameColumn()"
    (keydown)="null"
    [text]="nameColumnHidden ? 'TRANS__OPERATIONS__SHOW_NAME_COLUMN' : 'TRANS__OPERATIONS__HIDE_NAME_COLUMN'"
    [disabled]="false"
  ></app-dropdown-menu-item>
</app-dropdown-menu>
